import { get } from './coreApi';

export interface CommandCentreInstanceBranding {
  logoUrl?: string | null;
  backgroundColor?: string | null;
  textColor?: string | null;
}

export interface CommandCentreInstanceHosting {
  websiteUrl?: string | null;
  status?: string | null;
}

export interface CommandCentreInstance {
  id: number;
  instanceUniqueId: string | null;
  displayName: string;
  email?: string | null;
  logoUrl?: string | null;
  backgroundColor?: string | null;
  textColor?: string | null;
  createdAt?: string | null;
  updatedAt?: string | null;
  hosting?: CommandCentreInstanceHosting | null;
}

export interface CommandCentreInstanceUserRoleBinding {
  instance_id?: number;
  user_role?: string;
}

export interface CommandCentreInstanceUser {
  id: number;
  first_name: string;
  last_name: string;
  email: string;
  email_address: string;
  role: string;
  profilePicture?: string | null;
  profile_picture?: string | null;
  instance_roles?: CommandCentreInstanceUserRoleBinding[];
  last_active_at?: string | null;
  lastLoginAt?: string | null;
  updatedAt?: string | null;
}

interface ListInstancesResponse {
  instances?: CommandCentreInstance[];
}

interface GetInstanceResponse {
  instance?: CommandCentreInstance;
}

interface ListInstanceUsersResponse {
  users?: CommandCentreInstanceUser[];
  instance?: CommandCentreInstance;
}

interface ListInternalUsersResponse {
  users?: CommandCentreInstanceUser[];
}

export const listInstances = async (): Promise<CommandCentreInstance[]> => {
  const response = await get<ListInstancesResponse>('/command-center/instances');
  return Array.isArray(response.instances) ? response.instances : [];
};

export const getInstance = async (instanceId: number): Promise<CommandCentreInstance | null> => {
  const response = await get<GetInstanceResponse>(`/command-center/instances/${instanceId}`);
  return response.instance || null;
};

export const getInstanceByUniqueId = async (
  instanceUniqueId: string
): Promise<CommandCentreInstance | null> => {
  const response = await get<GetInstanceResponse>(
    `/command-center/instances/by-unique-id/${encodeURIComponent(instanceUniqueId)}`
  );
  return response.instance || null;
};

export const listInstanceUsers = async (
  instanceId: number
): Promise<{ instance: CommandCentreInstance | null; users: CommandCentreInstanceUser[] }> => {
  const response = await get<ListInstanceUsersResponse>(`/command-center/instances/${instanceId}/users`);
  return {
    instance: response.instance || null,
    users: Array.isArray(response.users) ? response.users : [],
  };
};

export const listInternalUsers = async (): Promise<CommandCentreInstanceUser[]> => {
  const response = await get<ListInternalUsersResponse>('/command-center/internal-users');
  return Array.isArray(response.users) ? response.users : [];
};
